/**
 * Whether sounds are written down as well as played.
 *
 * Writes to [captionPreference](../../captions/captionPreference.ts), which the captions overlay
 * reads per tick, so a player who turns it on from a paused game reads the next thing anybody says.
 *
 * Off by default, which is the one default on this screen chosen against the people the section is
 * for. A caption is text over the world, and a player who can hear the shout would be given a line
 * covering the thing they were listening to. One switch away is the right distance for a channel
 * that is decisive for some players and clutter for the rest.
 */

import { DEFAULT_AUDIO_CAPTIONS, setAudioCaptions } from '@/ui/captions/captionPreference';
import { SETTING_AUDIO_CAPTIONS_HINT, SETTING_AUDIO_CAPTIONS_LABEL } from '@/text/settingsText';
import { toggleApply, toggleValue } from '@/ui/settings/controls/toggleSwitch';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const AUDIO_CAPTIONS: SettingDefinition = {
  id: 'audioCaptions',
  section: 'accessibility',
  label: SETTING_AUDIO_CAPTIONS_LABEL,
  hint: SETTING_AUDIO_CAPTIONS_HINT,
  control: { kind: 'toggle' },
  defaultValue: toggleValue(DEFAULT_AUDIO_CAPTIONS),
  apply: toggleApply(setAudioCaptions),
};
